<ion-card class="card-common main-card ion-no-margin ion-margin-bottom"
    [class.selected]="selectedIndex === currentIndex()">
    <!-- Card header: registration number only (no feature-flagged notification icon) -->
    <ion-card-header class="card-header">
        <ion-toolbar class="bg-transparent ion-no-padding pt-2 pb-2">
            <!-- Vehicle registration number -->
            <ion-label slot="start">
                <ion-text class="reg-plate text-dark text-center">
                    {{ vehicle()?.reG_NUMBER }}
                </ion-text>
            </ion-label>
        </ion-toolbar>
    </ion-card-header>


    <!-- Card content -->
    <ion-card-content>
        <ion-row>
            <!-- Vehicle image -->
            <ion-col sizeXs="12" sizeMd="3" class="d-flex align-items-center justify-content-center">
                <ion-img class="car-image" [src]="getVehicleImage()" [alt]="vehicle()?.vehiclE_IMAGE_TYPE">
                </ion-img>
            </ion-col>

            <!-- Vehicle details -->
            <ion-col sizeXs="12" sizeMd="9" class="right-content text-dark">
                <!-- Make and model -->
                <ion-row class="vehicle-name font-family-bold">
                    <ion-col size="12">
                        <ion-text>
                            {{ vehicle()?.makE_NAME || '-' }}
                        </ion-text>

                        <div class="fw-normal xswidth360px">
                            {{ vehicle()?.modeL_NAME || '-' }}
                            {{ vehicle()?.modeL_TRIM }}
                        </div>
                    </ion-col>
                </ion-row>

                <!-- Odometer information -->
                <ion-row class="odometer-row fw-normal">
                    <ion-col [size]="isMobileApp()? 8:4">
                        <ion-text>
                            {{ 'A_LABEL2' | translate }} :
                        </ion-text>
                    </ion-col>

                    <ion-col [size]="isMobileApp()? 4:8" [ngClass]="isMobileApp() ? 'd-flex justify-content-end' : ''">
                        <ion-text class="value">
                            {{ vehicle()?.currenT_ODOM | formatNumber }}
                        </ion-text>
                    </ion-col>
                </ion-row>
            </ion-col>
        </ion-row>

        <!-- Action buttons -->
        <ion-toolbar class="bg-transparent">
            <ion-buttons [slot]="isMobileApp() ? '' : 'end' "
                class="toolbar-btn-group text-white d-flex align-items-center"
                [ngClass]="{'flex-column gap-2': isMobileApp()}">

                <!-- Inspect action -->
                @if (isInspect()) {
                <ion-button (click)="navigatePui()" [ngClass]="{
                    'w-100 btn_secondary_outline': isMobileApp(), 'btn_secondary': !isMobileApp()}"
                    (keydown.enter)="navigatePui()" routerDirection="root">
                    <ion-text [ngClass]="{'text-white': !isMobileApp()}">
                        {{ 'BTN_TEXT3' | translate }}
                    </ion-text>
                </ion-button>
                }

            </ion-buttons>
        </ion-toolbar>
    </ion-card-content>

</ion-card>